const PreHeading = ({ ...props }) => {
  return <p {...props} />;
};

export default PreHeading;
